import template from './info-modal.html';
import confirmationTemplate from './confirmation-modal.html';
import ModalController from './modal-controller';

export const SIZE_LARGE = 'lg';
export const SIZE_MEDIUM = 'md';
export const SIZE_SMALL = 'sm';

export default function ModalFactory(
    $uibModal,
    $rootScope
) {
    'ngInject';

    return {
        createInfoModal,
        openModal,
		createConfirmationModal,
    };

    function createInfoModal(title, text, size) {
        const scope = $rootScope.$new();

        Object.assign(scope, {
            title,
            text,
        });
        const sizeOption = (size) ? size : SIZE_LARGE;
        const options = {
            scope,
            controller: ModalController,
            controllerAs: 'modalCtrl',
            template,
            size: sizeOption,
        };
        return function() {
            return openModal(options).result;
        };
    }

	function createConfirmationModal(title, text, size, callback) {
        const scope = $rootScope.$new();

        Object.assign(scope, {
            title,
            text,
            callback,
        });
		const sizeOption = (size) ? size : SIZE_LARGE;
        const options = {
            scope,
            controller: ModalController,
            controllerAs: 'modalCtrl',
            template: confirmationTemplate,
            size: sizeOption,
        };
        return function() {
            return openModal(options).result;
        };
    }

	function openModal(options) {
        const scope = $rootScope.$new();
        const defaultOptions = {
            scope,
            size: SIZE_LARGE,
            dismissable: true,
            controller: ModalController,
            controllerAs: 'modalCtrl',
        };
        const modalOptions = Object.assign({}, defaultOptions, options);
        return $uibModal.open(modalOptions);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/modal/modal-service.js